import PropTypes from 'prop-types';
import React, { Component } from 'react';
import identify from "~/identify";
import MessageList from "~/ui/MessageList/MessageList";
//import get from 'lodash/get';
//import cn from 'classnames';
//import css from './css.css';

export default class ItemViewMessageList extends Component {
	static propTypes = {
	
	};

    filterMessages = (messages) => {
        let { view } = this.props;

        if(view === identify.VIEW_VIEW) {
            return messages.filter((messageData) => {
                return messageData.source !== 'saveResult';
            });
        } else {
            return messages;
        }
    };

	render() {
		return (
            <MessageList {...this.props} filterMessages={this.filterMessages} />
		);
	}
}